module.exports = __webpack_public_path__ + "img/IH_UC_original.42f86287.png";